export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const;
export const CLICK_ID_KEYS = ['gclid', 'fbclid', 'msclkid', 'ttclid'] as const;
export const ALL_ATTRIBUTION_KEYS = [...UTM_KEYS, ...CLICK_ID_KEYS] as const;
